import MuiCheckbox from "@mui/material/Checkbox";

export default function Checkbox(props) {
  return <MuiCheckbox {...props} />;
}
